<template>
    <div>
        <div class="d-flex mb-3 align-items-center justify-content-end">
            <a href="#" class="blue-link" @click.prevent="setTab(Tabs.VIEW)" v-if="tab === Tabs.ACTION">
                <i class="fa fa-arrow-left"></i>
                {{ __('GO BACK') }}
            </a>

            <a href="#" class="blue-link" @click.prevent="setTab(Tabs.ACTION)" v-if="tab === Tabs.VIEW">
                <i class="fa fa-plus"></i>
                {{ __('CREATE NEW ALERT') }}
            </a>
        </div>

        <component 
            :is="currentComponent"
            :availableChannels="availableChannels"
            :sentimentGroups="sentimentGroups"
            :groupId="groupId"
            :ruleToEdit="ruleToEdit"
        />
    </div>
</template>

<script>
import GroupReviewAlertsView from "./GroupReviewAlertsView";
import GroupReviewAlertsAction from "./GroupReviewAlertsAction";

export default {
    components: {
        GroupReviewAlertsView,
        GroupReviewAlertsAction
    },
    props: {
        availableChannels: Array,
        sentimentGroups: Array,
        groupId: Number,
    },
    data() {
        const Tabs = {
            VIEW: 'group-review-alerts-view',
            ACTION: 'group-review-alerts-action'
        };

        return {
            tab: Tabs.VIEW,
            ruleToEdit: null,
            Tabs
        };
    },
    computed: {
        currentComponent() {
            return this.tab === this.Tabs.VIEW ? 'GroupReviewAlertsView' : 'GroupReviewAlertsAction';
        }
    },
    created() {
        this.$on('edit-alert', rule => {
            this.ruleToEdit = rule;
            this.setTab(this.Tabs.ACTION);
        });
    },
    methods: {
        setTab(tab) {
            if (tab === this.Tabs.VIEW) {
                this.ruleToEdit = null;
            }
            this.tab = tab;
        },
    }
};
</script>